import { render, staticRenderFns } from "./DataTableEmpty.vue?vue&type=template&id=d41177a8&scoped=true"
import script from "./DataTableEmpty.vue?vue&type=script&lang=js"
export * from "./DataTableEmpty.vue?vue&type=script&lang=js"
import style0 from "./DataTableEmpty.vue?vue&type=style&index=0&id=d41177a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41177a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
